// CUSTOM CONFIGS
const appConfig = {
  apiUrl : process.env.VUE_APP_API_URL || 'http://api.publinet.localhost'
}

export default appConfig
